import { useEffect, useRef, useState } from "react";
import { useInView } from "framer-motion";
import { STATS, BRAND } from "../../data/content";
import { Reveal } from "../shared";

function CountUp({ end, decimals = 0, suffix = "", duration = 2.2 }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, amount: 0.6 });
  const [val, setVal] = useState(0);

  useEffect(() => {
    if (!inView) return;
    let raf;
    const start = performance.now();
    const tick = (t) => {
      const p = Math.min(1, (t - start) / (duration * 1000));
      const eased = 1 - Math.pow(1 - p, 3);
      setVal(end * eased);
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [inView, end, duration]);

  return (
    <span ref={ref} data-testid={`counter-${end}`}>
      {val.toFixed(decimals)}
      {suffix}
    </span>
  );
}

export default function Stats() {
  return (
    <section className="bg-ivory" data-testid="stats-section">
      <div className="mx-auto max-w-7xl px-6 py-16 md:px-12 md:py-20">
        <div className="grid grid-cols-2 gap-y-12 md:grid-cols-4">
          {STATS.map((s, i) => (
            <Reveal key={s.label} delay={i * 0.1} className={`text-center px-4 ${i < 3 ? "md:border-r md:border-gold/20" : ""}`}>
              <p className="font-serif text-5xl md:text-6xl text-emerald leading-none">
                <CountUp end={s.end} decimals={s.decimals} suffix={s.suffix} />
              </p>
              <p className="mt-3 text-[10px] md:text-[11px] uppercase tracking-[0.25em] text-stone2">{s.label}</p>
            </Reveal>
          ))}
        </div>
        <Reveal delay={0.3}>
          <div className="mt-14 flex items-center justify-center gap-4 text-[11px] uppercase tracking-[0.3em] text-gold-text">
            <span className="h-px w-10 bg-gold/50" />
            {BRAND.locations.join("  ·  ")}
            <span className="h-px w-10 bg-gold/50" />
          </div>
        </Reveal>
      </div>
    </section>
  );
}
